/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdApplicationPublicDataBuilderVkontakteComOauthOptions, FxIdApplicationPublicDataBuilderVkontakteComOauthOptionsFromJSONTyped, FxIdApplicationPublicDataBuilderVkontakteComOauthOptionsToJSON, } from './FxIdApplicationPublicDataBuilderVkontakteComOauthOptions';
export function FxIdApplicationPublicDataBuilderAuthOptionsVkontakteComOauthFromJSON(json) {
    return FxIdApplicationPublicDataBuilderAuthOptionsVkontakteComOauthFromJSONTyped(json, false);
}
export function FxIdApplicationPublicDataBuilderAuthOptionsVkontakteComOauthFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationPublicDataBuilderVkontakteComOauthOptions(json)) {
        return FxIdApplicationPublicDataBuilderVkontakteComOauthOptionsFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdApplicationPublicDataBuilderAuthOptionsVkontakteComOauthToJSON(json) {
    return FxIdApplicationPublicDataBuilderAuthOptionsVkontakteComOauthToJSONTyped(json, false);
}
export function FxIdApplicationPublicDataBuilderAuthOptionsVkontakteComOauthToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdApplicationPublicDataBuilderVkontakteComOauthOptions(value)) {
        return FxIdApplicationPublicDataBuilderVkontakteComOauthOptionsToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdApplicationPublicDataBuilderAuthOptionsVkontakteComOauth.js.map